import type { Language } from '../content/content';

const GOOGLE_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSdhWesWhgJdOyOaf_pP8pxk2jsem5xaeNLF2SWTMvHu_fxh3A/viewform?usp=sharing&ouid=112436039661662456910';

export const GOOGLE_FORM_ES_URL = GOOGLE_FORM_URL;
export const GOOGLE_FORM_EN_URL = GOOGLE_FORM_URL;

export function getSurveyUrl(language: Language): string {
  const base = language === 'es' ? GOOGLE_FORM_ES_URL : GOOGLE_FORM_EN_URL;
  if (!base) return '';

  const url = new URL(base);
  url.searchParams.set('utm_source', 'qr_museo');
  url.searchParams.set('utm_medium', 'offline');
  url.searchParams.set('utm_campaign', 'recorrido_guiado');
  url.searchParams.set('utm_content', language);
  return url.toString();
}
